<form class="p-30 flex flex-col" *ngIf="detailForm" [formGroup]="detailForm">
  <div class="flex flex-col">

    <div class="flex flex-row justify-start items-start auto-flex" *ngIf="isEditing.firstName === false">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" (click)="editField('firstName')">
      </mat-form-field>
    </div>
    <particle-inplace-input *ngIf="isEditing.firstName === true"
                            [text]="detailForm.value.firstName"
                            placeHolder="First Name"
                            (valueChanged)="updateFirstName($event)"
                            (cancelled)="resetEditing()">
    </particle-inplace-input>

    <div class="flex flex-row justify-start items-start auto-flex" *ngIf="isEditing.lastName === false">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" (click)="editField('lastName')">
      </mat-form-field>
    </div>
    <particle-inplace-input *ngIf="isEditing.lastName === true"
                            [text]="detailForm.value.lastName"
                            placeHolder="Last Name"
                            (valueChanged)="updateLastName($event)"
                            (cancelled)="resetEditing()">
    </particle-inplace-input>

    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Company Name</mat-label>
        <input matInput formControlName="companyName">
      </mat-form-field>
    </div>

    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Designation</mat-label>
        <input matInput formControlName="designation">
      </mat-form-field>
    </div>

    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>
    </div>

    <div class="flex flex-row justify-start items-start auto-flex" *ngIf="isEditing.userNote === false">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Notes</mat-label>
        <input matInput formControlName="userNote" (click)="editField('userNote')">
      </mat-form-field>
    </div>
    <particle-inplace-input *ngIf="isEditing.userNote === true"
                            [text]="detailForm.value.userNote"
                            placeHolder="Notes"
                            (valueChanged)="updateUserNote($event)"
                            (cancelled)="resetEditing()">
    </particle-inplace-input>

    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-checkbox formControlName="isActive" (change)="updateUserData()">Is Active</mat-checkbox>
    </div>

  </div>
</form>
